export enum Notification {
    Name = 'Notification',
    SubscribeToRoles = 'SubscribeToRoles',
    ReceiveNotification = 'ReceiveNotification',
    SendMessageToUser = 'SendMessageToUser'
}
